var render, staticRenderFns
import script from "./HKLCreateButton.vue?vue&type=script&lang=js&"
export * from "./HKLCreateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15bcaa0a')) {
      api.createRecord('15bcaa0a', component.options)
    } else {
      api.reload('15bcaa0a', component.options)
    }
    
  }
}
component.options.__file = "src/controls/Button/HKLCreateButton.vue"
export default component.exports